const breadCrumb =
  "Lotação de Servidores - Manutenção de Informações do Servidor";

const routes = [
  {
    path: "/cadastro-de-lotacao-de-servidor",
    name: "cadastro-de-lotacao-de-servidor",
    meta: {
      allowedPermissions: ["lotacao_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/LotacaoDeServidor/LotacaoDeServidorHome.vue"),
  },
  {
    path: "/cadastro-de-lotacao-de-servidor/:servidorId/novo/:anoLotacao",
    name: "cadastro-de-lotacao-de-servidor-novo",
    meta: {
      allowedPermissions: ["lotacao_list", "lotacao_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/LotacaoDeServidor/LotacaoDeServidorCad.vue"),
  },
  {
    path: "/cadastro-de-lotacao-de-servidor/:servidorId/editar/:localServidorId",
    name: "cadastro-de-lotacao-de-servidor-editar",
    meta: {
      allowedPermissions: ["lotacao_list", "lotacao_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/LotacaoDeServidor/LotacaoDeServidorEdit.vue"),
  },
  {
    path: "/cadastro-de-lotacao-de-servidor/:servidorId/visualizar/:localServidorId",
    name: "cadastro-de-lotacao-de-servidor-visualizar",
    meta: {
      allowedPermissions: ["lotacao_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/LotacaoDeServidor/LotacaoDeServidorVisualizar.vue"),
  },
];

export default routes;
